import React, { useContext } from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSwireApp } from 'react-hooks';
import { AppContext, ChannelsContext } from 'lane-shared/contexts';

import { WhitelabeledLogo, Loading, ModalBackground } from 'components/general';
import PoweredBy from 'components/lane/PoweredBy';
import { S, XS } from 'components/typography';

import styles from './TransitionPage.scss';

type TransitionPageProps = {
  message?: {
    title?: string;
    subTitle?: string;
  };
  isOpen?: boolean;
};

export default function TransitionPage({
  message = {},
  isOpen,
}: TransitionPageProps) {
  const { isTransitioning, whitelabel } = useContext(AppContext);
  const { t } = useTranslation();
  const { primaryChannel, primaryChannelInitialized } =
    useContext(ChannelsContext);
  const { isSwire: isSwireDomain } = useSwireApp(whitelabel);

  if (primaryChannel && primaryChannelInitialized) {
    message.title = message.title || primaryChannel.name;
    message.subTitle = message.subTitle || primaryChannel.address?.street1;
  }

  const { title, subTitle } = message;

  const getTitle = () => {
    if (isSwireDomain) {
      return t('shared.swire.identifyUser.successfull.registration-heading');
    }

    return title;
  };

  const getSubTitle = () => {
    if (isSwireDomain) {
      return t(
        'shared.swire.identifyUser.successfull.registration-description'
      );
    }

    return title !== subTitle ? subTitle : null;
  };

  return (
    <ModalBackground
      isOpen={isOpen || isTransitioning}
      onClose={() => undefined}
    >
      <div className={cx(styles.content)}>
        <div className={styles.channelInfo}>
          {!isSwireDomain && (
            <XS variant="secondary" mb={4}>
              {t('Entering...')}
            </XS>
          )}
          <WhitelabeledLogo size={112} />
          <S variant="secondary" mt={4}>
            {getTitle()}
          </S>
          <XS variant="secondary" className={styles.addressInfo} mt={2}>
            {getSubTitle()}
          </XS>
        </div>
        <Loading className={styles.loadingIndicator} />
        <PoweredBy />
      </div>
    </ModalBackground>
  );
}
